export const PRELOAD_DATA = 'PRELOAD_DATA';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_QUERY_RESULTS = 'SET_QUERY_RESULTS';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_REGION = 'SET_REGION';
export const SET_QUERY = 'SET_QUERY';
export const ADD_QUERY_RESULT = 'ADD_QUERY_RESULT';
export const POP_QUERY_RESULT = 'POP_QUERY_RESULT';
export const SET_COLOR = 'SET_COLOR';
export const SET_IS_HORIZONTAL_LAYOUT = 'SET_IS_HORIZONTAL_LAYOUT';
export const SET_CANVAS_SIZE = 'SET_CANVAS_SIZE';
export const PREVIEW = 'PREVIEW';
export const SET_MAP_PRINT_REVIEW_IMAGE_URL = 'SET_MAP_PRINT_PREVIEW_IMAGE_URL';
export const SET_ERROR = 'SET_ERROR';
export const SET_ANALYTICS = 'SET_ANALYTICS';